import React, { useEffect, useRef, useState } from "react";
import HeroHeader from "./HeroHeader";
import NavButtons from "./NavButtons";
import CardSection from "./CardSection";

const NAV_OPTIONS = ["Popular", "Tech", "Services", "Integrations"];

const AddOns = () => {
  const [config, setConfig] = useState({
    selectedOption: "Popular",
    scroll: false,
  });
  const rootRef = useRef(null);
  const popularRef = useRef(null);
  const techRef = useRef(null);
  const servicesRef = useRef(null);
  const integrationsRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([{ isIntersecting, target }]) => {
        if (isIntersecting) {
          if (target === popularRef.current) setConfig({ selectedOption: "Popular" });
          if (target === techRef.current) setConfig({ selectedOption: "Tech" });
          if (target === servicesRef.current) setConfig({ selectedOption: "Services" });
          if (target === integrationsRef.current) setConfig({ selectedOption: "Integrations" });
        }
      },
      { root: rootRef.current, threshold: 0.8 },
    );
    observer.observe(popularRef.current);
    observer.observe(techRef.current);
    observer.observe(servicesRef.current);
    observer.observe(integrationsRef.current);
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (!config.scroll) return;
    const behavior = { block: "center", behavior: "smooth" };
    if (config.selectedOption === "Popular") popularRef.current.scrollIntoView(behavior);
    if (config.selectedOption === "Tech") techRef.current.scrollIntoView(behavior);
    if (config.selectedOption === "Services") servicesRef.current.scrollIntoView(behavior);
    if (config.selectedOption === "Integrations") integrationsRef.current.scrollIntoView(behavior);
  }, [config]);

  return (
    <div className="tw-flex tw-flex-col tw-gap-[64px] tw-max-h-full tw-overflow-auto" ref={rootRef}>
      <HeroHeader />

      <NavButtons
        options={NAV_OPTIONS}
        value={config.selectedOption}
        onChange={(selectedOption) => setConfig({ selectedOption, scroll: true })}
      />

      <CardSection title="Popular" ref={popularRef} />
      <CardSection title="Tech Enhancements" ref={techRef} />
      <CardSection title="Brivity Services" ref={servicesRef} />
      <CardSection title="Integrations" ref={integrationsRef} />
    </div>
  );
};

export default AddOns;
